<template>
  <div class="w-full">
    <ToggleMarketWithSubMarket
      v-if="marketWithSubMarket.subMarkets.length > 0"
      v-bind="$props"
      @selected="
        (selectedMarket: MarketWithSubMarkets) =>
          $emit('selected', selectedMarket)
      "
    />
    <ToggleMarketOnly
      v-else
      :key
      :market="marketWithSubMarket.market"
      :should-show-collection-point-options
      v-bind="$props"
      @selected="
        (selectedMarket: MarketWithSubMarkets) =>
          $emit('selected', selectedMarket)
      "
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { MarketWithSubMarkets } from '@backmarket/http-api/src/api-specs-shipping/rules'

import type { ShippingCategoryGroupMetadata } from '../../CategoryList.types.js'
import type { FormMethodValues } from '../RuleDrawer/RuleDrawer.types.js'

import ToggleMarketOnly from './ToggleMarketOnly.vue'
import ToggleMarketWithSubMarket from './ToggleMarketWithSubMarket.vue'

const props = defineProps<{
  marketWithSubMarket: MarketWithSubMarkets
  categoryGroupMetadata: ShippingCategoryGroupMetadata
  currentSelection: MarketWithSubMarkets[]
  currentMethods: FormMethodValues[]
  otherMethods: FormMethodValues[]
  isFree: boolean
  shouldShowCollectionPointOptions?: boolean
}>()

defineEmits(['selected'])

const key = computed(() => {
  if (props.shouldShowCollectionPointOptions) {
    return '-collection-point'
  }

  return props.isFree ? `free${props.marketWithSubMarket.market}` : 'paid'
})
</script>
